import React from 'react'
// libs
import styled from 'styled-components'
// components
import MenuItemOrigin from '@mui/material/MenuItem'
// themes
import { colors } from 'themes/index'

const Wrapper = styled('div')`
  padding: 8px 0;
`

const MenuItem = styled(MenuItemOrigin)`
  && {
    color: ${colors.blue500};
    min-height: inherit;
    padding: 4px 12px;
  }
` as typeof MenuItemOrigin

interface Props {
  closePopup: () => void
  handleEditClick: () => void
  handleRevokeClick: () => void
}

const Menu: React.FC<Props> = ({ closePopup, handleEditClick, handleRevokeClick }) => {
  const handleEdit = () => {
    closePopup()
    handleEditClick()
  }

  const handleRevoke = () => {
    closePopup()
    handleRevokeClick()
  }

  return (
    <Wrapper>
      <MenuItem onClick={handleEdit}>Edit</MenuItem>
      <MenuItem onClick={handleRevoke}>Revoke</MenuItem>
    </Wrapper>
  )
}

export default Menu
